import { classNames } from "../../utils/classNames";

export function ComboboxLabel({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"span"> & { icon?: boolean }) {
  return (
    <span
      className={classNames(
        className,
        "ml-2.5 truncate first:ml-0 sm:ml-2 sm:first:ml-0",
      )}
      {...props}
    />
  );
}
